const AboutMe = () => {
    return ( 
        <>
            <h2>About Me</h2>

        </>
     );
}
 
export default AboutMe;